const MAX_BREADCRUMBS = 20;

export type BreadcrumbCategory =
  | 'ui.click'
  | 'ui.nav'
  | 'office.event'
  | 'office.call'
  | 'api.request'
  | 'api.response'
  | 'mutation'
  | 'auth';

export interface Breadcrumb {
  ts: number;
  category: BreadcrumbCategory;
  message: string;
  data?: Record<string, unknown>;
}

const buffer: Breadcrumb[] = [];

export function addBreadcrumb(crumb: Omit<Breadcrumb, 'ts'>): void {
  buffer.push({ ...crumb, ts: Date.now() });
  if (buffer.length > MAX_BREADCRUMBS) {
    buffer.splice(0, buffer.length - MAX_BREADCRUMBS);
  }
}

export function getBreadcrumbs(): Breadcrumb[] {
  return [...buffer];
}

export function clearBreadcrumbs(): void {
  buffer.length = 0;
}
